import React from 'react';
import {RsnIconWidget, RsnSkeleton, styles} from '~/library/ui-kit';
import defaultIcon from '~/shared/legacy_res/img/svg/default.svg';

export function OperationSelectButton({
    label: labelText,
    iconSrc,
    heading,
    details,
}: {
    label: string;
    iconSrc: string | null;
    heading: React.ReactNode;
    details: React.ReactNode;
}) {
    return (
        <div className='flex flex-col gap-2'>
            <label className='fv-text-m text-neutral-100'>{labelText}</label>
            <RsnIconWidget.Sm
                as='button'
                type='button'
                className={cls.buttonBox}
                icon={{src: iconSrc ?? defaultIcon}}
                disabled
            >
                <RsnIconWidget.TextBlock heading={heading} details={details} />
            </RsnIconWidget.Sm>
        </div>
    );
}

const cls = styles({
    buttonBox:
        'rounded-lg p-3 shadow disabled:cursor-default disabled:border disabled:border-neutral-20 disabled:bg-neutral-20 disabled:shadow-[none]',
});

OperationSelectButton.Skeleton = function OperationSelectButtonSkeleton() {
    return (
        <div className='grid gap-2'>
            <RsnSkeleton width={32} height={12} />
            <div className='flex gap-2 rounded-sm border border-solid border-neutral-40 p-3'>
                <RsnSkeleton circle width={36} height={36} />
                <div className='grid flex-1 gap-2'>
                    <RsnSkeleton width={64} height={12} />
                    <RsnSkeleton width={140} height={8} />
                </div>
            </div>
        </div>
    );
};
